export class BillReaderUser {
	public userId: string;
	public username: string;
	public email: string;
	public role: string;
	public isActive: boolean;
	public createdAt: string | Date;
	public updatedAt: string | Date;
	public lastSeenAt: string | Date;
	public tokenExpiresAt: string | Date;

	constructor(billReaderUser?: BillReaderUser) {
		Object.assign(this, billReaderUser);
	}
}
